<template>
  <div class="grid" :class="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseGrid',
  props: {
    columns: {
      type: Number,
      default: 4
    }
  },
  computed: {
    style () {
      var css = ''
      switch (this.columns) {
        case 4:
          css = 'grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
          break
        case 3:
          css = 'grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3'
          break
        case 2:
          css = 'grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2'
          break
      }
      return css
    }
  }
}
</script>

<style scoped lang="scss">
</style>
